import {
  CustomEvent,
  BadClickType,
  ImpactType,
  Opportunity,
  SeenEvent,
  Signal,
  DimensionType,
  SignalType,
  PageView,
} from '@fullstory/proto/fs/services/alexa';
import { DateRangeId } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';
import {
  CustomQueryProto,
  ImpactsTableConfig,
  MutedOpportunityConfig,
} from '@fullstory/proto/fs/services/webber/internal/impacts';
import { DateRange, DateRangeID } from '@fullstory/client-api';
import { WithID } from '@fullstory/util/uid';
import { DisplayCurrencyType } from '@fullstory/proto/fs/services/webber/frontend/display';
import { DefinedEvent } from '@fullstory/proto/fs/services/search-settings';
import { SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { FunnelDetail, SegmentDetail } from '@fullstory/proto/fs/services/dx-objects';
import { int64 } from '@fullstory/proto/google/protobuf';
import { intl } from '@fullstory/intl';

export enum ImpactTypes {
  ComputeDimensionsRequest = 'Impacts.COMPUTE_DIMENSIONS_REQUEST',
  ComputeDimensionsSuccess = 'Impacts.COMPUTE_DIMENSIONS_SUCCESS',
  ComputeDimensionsFailure = 'Impacts.COMPUTE_DIMENSIONS_FAILURE',
  GenerateSignalsRequest = 'Impacts.GENERATE_SIGNALS_REQUEST',
  GenerateSignalsSuccess = 'Impacts.GENERATE_SIGNALS_SUCCESS',
  GenerateSignalsFailure = 'Impacts.GENERATE_SIGNALS_FAILURE',
  GenerateOpportunitiesRequest = 'Impacts.GENERATE_OPPORTUNITIES_REQUEST',
  GenerateOpportunitiesSuccess = 'Impacts.GENERATE_OPPORTUNITIES_SUCCESS',
  GenerateOpportunitiesFailure = 'Impacts.GENERATE_OPPORTUNITIES_FAILURE',
  GenerateOpportunityResults = 'Impacts.GENERATE_OPPORTUNITY_RESULTS',
  GenerateOpportunitiesBatchStarted = 'Impacts.GENERATE_OPPORTUNITIES_BATCH_STARTED',
  GenerateOpportunitiesBatchSuccess = 'Impacts.GENERATE_OPPORTUNITIES_BATCH_SUCCESS',
  GenerateOpportunitiesBatchFailure = 'Impacts.GENERATE_OPPORTUNITIES_BATCH_FAILURE',
  ComputeFunnelMetricsRequest = 'Impacts.COMPUTE_FUNNEL_METRICS_REQUEST',
  ComputeFunnelMetricsSuccess = 'Impacts.COMPUTE_FUNNEL_METRICS_SUCCESS',
  ComputeFunnelMetricsFailure = 'Impacts.COMPUTE_FUNNEL_METRICS_FAILURE',
  ChangePendingSegment = 'Impacts.ChangePendingSegment',
  ChangePendingFunnel = 'Impacts.ChangePendingFunnel',
  ChangePendingInputs = 'Impacts.ChangePendingInputs',
  SetOpportunityDetail = 'Impacts.SetOpportunityDetail',
  FilterRageClicks = 'Impacts.FilterRageClicks',
  FilterErrorClicks = 'Impacts.FilterErrorClicks',
  FilterDeadClicks = 'Impacts.FilterDeadClicks',
  FilterPagePerformance = 'Impacts.FilterPagePerformance',
  FilterAjaxErrors = 'Impacts.FilterAjaxErrors',
  FetchImpactsConfigRequest = 'Impacts.FetchImpactsConfig.Request',
  FetchImpactsConfigSuccess = 'Impacts.FetchImpactsConfig.Success',
  FetchImpactsConfigFailed = 'Impacts.FetchImpactsConfig.Failed',
  ConfigCreateStarted = 'Impacts.ConfigCreate.Started',
  ConfigCreateSuccess = 'Impacts.ConfigCreate.Success',
  ConfigCreateFailed = 'Impacts.ConfigCreate.Failed',
  ConfigUpdateStarted = 'Impacts.ConfigUpdate.Started',
  ConfigUpdateSuccess = 'Impacts.ConfigUpdate.Success',
  ConfigUpdateFailed = 'Impacts.ConfigUpdate.Failed',
  ConfigLoad = 'Impacts.ConfigLoad',
  ConfigNew = 'Impacts.ConfigNew',
  ConfigChanged = 'Impacts.ConfigChanged',
  SetPendingCannedDateRangeID = 'Impacts.SetPendingCannedDateRangeID',
  SetPendingStartDate = 'Impacts.SetPendingStartDate',
  SetPendingEndDate = 'Impacts.SetPendingEndDate',
  ConfigDeleteSuccess = 'Impacts.ConfigDeleteSuccess',
  ConfigDeleteFailure = 'Impacts.ConfigDeleteFailure',
  SetDetailFocusedStep = 'Impacts.Detail.SetStep',
  SetUserSentenceConverted = 'Impacts.SessionReplay.Converted',
  SetUserSentenceHadExperience = 'Impacts.SessionReplay.HadExperience',
  ConfigShowModal = 'Impacts.ConfigShowModal',
  SetOpportunityBatchVersion = 'Impacts.OpportunityBatchVersion.Set',
  FetchOpportunitySnapshotsRequest = 'Impacts.FetchOpportunitySnapshots.Request',
  FetchOpportunitySnapshotsSuccess = 'Impacts.FetchOpportunitySnapshots.Success',
  FetchOpportunitySnapshotsFailure = 'Impacts.FetchOpportunitySnapshots.Failure',
  FetchOpportunitySnapshotRequest = 'Impacts.FetchOpportunitySnapshot.Request',
  FetchOpportunitySnapshotSuccess = 'Impacts.FetchOpportunitySnapshot.Success',
  FetchOpportunitySnapshotFailure = 'Impacts.FetchOpportunitySnapshot.Failure',
  CreateOpportunitySnapshotRequest = 'Impacts.CreateOpportunitySnapshot.Request',
  CreateOpportunitySnapshotSuccess = 'Impacts.CreateOpportunitySnapshot.Success',
  CreateOpportunitySnapshotFailure = 'Impacts.CreateOpportunitySnapshot.Failure',
  CreateOpportunitySnapshotShareLinkRequest = 'Impacts.CreateOpportunitySnapshotShareLink.Request',
  CreateOpportunitySnapshotShareLinkSuccess = 'Impacts.CreateOpportunitySnapshotShareLink.Success',
  CreateOpportunitySnapshotShareLinkFailure = 'Impacts.CreateOpportunitySnapshotShareLink.Failure',
  SetShareLinkPopover = 'Impacts.SetShareLinkPopover',
  DeleteOpportunitySnapshotRequest = 'Impacts.DeleteOpportunitySnapshot.Request',
  DeleteOpportunitySnapshotSuccess = 'Impacts.DeleteOpportunitySnapshot.Success',
  DeleteOpportunitySnapshotFailure = 'Impacts.DeleteOpportunitySnapshot.Failure',
  SetDeleteSnapshotPending = 'Impacts.SetDeleteSnapshotPending',
  GetOpportunitySnapshotShareLinksRequest = 'Impacts.GetOpportunitySnapshotShareLinks.Request',
  GetOpportunitySnapshotShareLinksSuccess = 'Impacts.GetOpportunitySnapshotShareLinks.Success',
  GetOpportunitySnapshotShareLinksFailure = 'Impacts.GetOpportunitySnapshotShareLinks.Failure',
  SetSnapshotId = 'Impacts.SetSnapshotId',
  RevenueEventRequest = 'Impacts.RevenueEventRequest',
  RevenueEventSuccess = 'Impacts.RevenueEventSuccess',
  RevenueEventFailure = 'Impacts.RevenueEventFailure',
  FetchAverageOrderValueRequest = 'Impacts.FetchAverageOrderValueRequest',
  FetchAverageOrderValueSuccess = 'Impacts.FetchAverageOrderValueSuccess',
  FetchAverageOrderValueFailure = 'Impacts.FetchAverageOrderValueFailure',
  FetchTotalRevenueRequest = 'Impacts.FetchTotalRevenueRequest',
  FetchTotalRevenueSuccess = 'Impacts.FetchTotalRevenueSuccess',
  FetchTotalRevenueFailure = 'Impacts.FetchTotalRevenueFailure',
  GetMutedOpportunityConfigsRequest = 'Impacts.GetMutedOpportunityConfigs.Request',
  GetMutedOpportunityConfigsSuccess = 'Impacts.GetMutedOpportunityConfigs.Success',
  GetMutedOpportunityConfigsFailure = 'Impacts.GetMutedOpportunityConfigs.Failure',
  MuteOpportunityRequest = 'Impacts.MuteOpportunity.Request',
  MuteOpportunitySuccess = 'Impacts.MuteOpportunity.Success',
  MuteOpportunityFailure = 'Impacts.MuteOpportunity.Failure',
  UnmuteOpportunityRequest = 'Impacts.UnmuteOpportunity.Request',
  UnmuteOpportunitySuccess = 'Impacts.UnmuteOpportunity.Success',
  UnmuteOpportunityFailure = 'Impacts.UnmuteOpportunity.Failure',
  UpdateGenerateOpportunitiesProgress = 'Impacts.UpdateGenerateOpportunitiesProgress',
  ListConversionsSpecSignalsRequest = 'Impacts.ListConversionsSpecSignalsRequest',
  ListConversionsSpecSignalsSuccess = 'Impacts.ListConversionsSpecSignalsSuccess',
  ListConversionsSpecSignalsFailure = 'Impacts.ListConversionsSpecSignalsFailure',
}

export const TodaySearchValue = 'NOW/DAY+1DAY';

export interface DateRangeType extends DateRange {
  dashboardOnly?: boolean;
  days: number;
}

export const DateRanges: DateRangeType[] = [
  {
    id: DateRangeID.Today,
    name: intl.formatMessage({ defaultMessage: 'Today', id: 'zWgbGg' }),
    range: { Start: 'NOW/DAY', End: TodaySearchValue },
    days: 1,
  },
  {
    id: DateRangeID.Yesterday,
    name: intl.formatMessage({ defaultMessage: 'Yesterday', id: '6dIxDP' }),
    range: { Start: 'NOW/DAY-1DAY', End: 'NOW/DAY' },
    days: 1,
  },
  {
    id: DateRangeID.Past60Minutes,
    name: intl.formatMessage({ defaultMessage: 'Past 60 minutes', id: 'dycj1L' }),
    range: { Start: 'NOW/MINUTE-59MINUTE', End: 'NOW/MINUTE+1MINUTE' },
    days: 1.0 / 24.0,
  },
  {
    id: DateRangeID.Past3Hours,
    name: intl.formatMessage({ defaultMessage: 'Past 3 hours', id: 'f9/17e' }),
    range: { Start: 'NOW/HOUR-2HOUR', End: 'NOW/HOUR+1HOUR' },
    days: 3.0 / 24.0,
  },
  {
    id: DateRangeID.Past6Hours,
    name: intl.formatMessage({ defaultMessage: 'Past 6 hours', id: '/WVb/X' }),
    range: { Start: 'NOW/HOUR-5HOUR', End: 'NOW/HOUR+1HOUR' },
    days: 6.0 / 24.0,
  },
  {
    id: DateRangeID.Past24Hours,
    name: intl.formatMessage({ defaultMessage: 'Past 24 hours', id: '/a7cg5' }),
    range: { Start: 'NOW/HOUR-23HOUR', End: 'NOW/HOUR+1HOUR' },
    days: 1,
  },
  {
    id: DateRangeID.PastWeek,
    name: intl.formatMessage({ defaultMessage: 'Past 7 days', id: 'mbbNJS' }),
    range: { Start: 'NOW/DAY-6DAY', End: TodaySearchValue },
    days: 7,
  },
  {
    id: DateRangeID.PastMonth,
    name: intl.formatMessage({ defaultMessage: 'Past 30 days', id: 'OIM20v' }),
    range: { Start: 'NOW/DAY-29DAY', End: TodaySearchValue },
    days: 30,
  },
  {
    id: DateRangeID.Past90Days,
    name: intl.formatMessage({ defaultMessage: 'Past 90 days', id: 'ZOWtIg' }),
    range: { Start: 'NOW/DAY-89DAY', End: TodaySearchValue },
    dashboardOnly: true,
    days: 90,
  },
  {
    id: DateRangeID.PastYear,
    name: intl.formatMessage({ defaultMessage: 'Past year', id: 'o0dtS/' }),
    range: { Start: 'NOW/DAY-364DAY', End: TodaySearchValue },
    dashboardOnly: true,
    days: 365,
  },
  // add in since and custom definitions
  {
    id: DateRangeID.Since,
    name: intl.formatMessage({ defaultMessage: 'Since', id: '+eH89J' }),
    range: { Start: '', End: TodaySearchValue },
    days: 0,
  },
  {
    id: DateRangeID.Custom,
    name: intl.formatMessage({ defaultMessage: 'Custom', id: 'Sjo1P4' }),
    range: { Start: '', End: '' },
    days: 0,
  },
];

export enum SortProperty {
  affectedUsers = 'affectedUsers',
  conversionDelta = 'conversionDelta',
  conversionsLost = 'conversionsLost',
  confidenceLevel = 'confidenceLevel',
  annualizedConversionsLost = 'annualizedConversionsLost',
  annualizedValue = 'annualizedValue',
}

export enum OpportunitiesLoadingStatus {
  reset = 'reset',
  fetchingSignals = 'fetchingSignals',
  fetchingOpportunities = 'fetchingOpportunities',
  done = 'done',
  failed = 'failed',
}

export type ConfigById = { [key: string]: ImpactsTableConfig };

export type MutedOppConfigsBySignalKey = { [signalKey: string]: MutedOpportunityConfig };

export interface Datum {
  data: number;
  percentage: number;
  class: string;
}

export interface ConversionSummaryData {
  data: Datum[];
  label: string;
}

export interface ConversionSummaryDataV2 {
  /** unique ID for this step */
  id: string;
  /** OVERALL STEP STATS */
  /** total users in funnel (unaffected + affected) */
  stepTotal: number;
  /** total % that made it through to this step (unaffected + affected) */
  stepTotalPercentage: number;

  /** LOSS - stepwise or simulated  */
  /** if it's a stepwise calculation */
  stepwise: boolean;
  /** if stepwise, and has lost conversions, absolute number of conversions lost for this step */
  lostConversions: number;
  /** % of conversions lost */
  conversionDelta: number;
  /** in the non-stepwise case, the simulated stepwise loss ("sprinkling" total conversions loss across affected steps) */
  simulatedStepwiseLoss: number;

  /** UNAFFECTED STATS */
  /** absolute number of unaffected at this step */
  unaffected: number;
  /** conversion % for unaffected */
  unaffectedConversion: number;

  /** AFFECTED STATS */
  /** absolute number of affected at this step */
  affected: number;
  /** conversion % for affected */
  affectedConversion: number;

  /** TOTALS (Entire Funnel)  */
  /** total conversions lost across the entire funnel */
  totalConversionsLost: number;

  /** total affected conversion % */
  totalAffectedConversion: number;
  /** total unaffected conversion % */
  totalUnaffectedConversion: number;
  /** display label for this step */
  label: string;
  /** significance flag per stepwise analysis */
  isSignificant: boolean;
}

export type ClickTypeFilter = {
  [BadClickType.CLICK_TYPE_DEAD]?: boolean;
  [BadClickType.CLICK_TYPE_RAGE]?: boolean;
  [BadClickType.CLICK_TYPE_ERROR]?: boolean;
};

export type ImpactTypeFilter = {
  [ImpactType.IMPACT_TYPE_PERF_EVENT]?: boolean;
  [ImpactType.IMPACT_TYPE_CUSTOM_QUERY]?: boolean;
  [ImpactType.IMPACT_TYPE_SEEN_EVENT]?: boolean;
  [ImpactType.IMPACT_TYPE_CUSTOM_EVENT]?: boolean;
  [ImpactType.IMPACT_TYPE_DEFINED_EVENT]?: boolean;
  [ImpactType.IMPACT_TYPE_AJAX_ERROR]?: boolean;
  [ImpactType.IMPACT_TYPE_CORE_WEB_VITALS]?: boolean;
  [ImpactType.IMPACT_TYPE_PAGE_VIEW]?: boolean;
  [ImpactType.IMPACT_TYPE_FID]?: boolean;
  [ImpactType.IMPACT_TYPE_LCP]?: boolean;
  [ImpactType.IMPACT_TYPE_CLS]?: boolean;
  [ImpactType.IMPACT_TYPE_INP]?: boolean;
  [ImpactType.IMPACT_TYPE_TTI]?: boolean;
  [ImpactType.IMPACT_TYPE_TBT]?: boolean;
  [ImpactType.IMPACT_TYPE_TTFB]?: boolean;
};

export type Inputs = {
  currentWatchedElements?: SeenEvent[];
  currentCustomEvents?: CustomEvent[];
  currentPageviewEvents?: PageView[];
  currentCustomQueries?: CustomQueryProto[];
  filterErrorClicks: boolean;
  filterRageClicks: boolean;
  filterDeadClicks: boolean;
  filterPagePerformance: boolean;
  filterAjaxErrors: boolean;
  currentDefinedEvents?: DefinedEvent[];
  /**
   * @deprecated should use the web vital options instead
   */
  filterCoreWebVitals: boolean;
  filterFid: boolean;
  filterLcp: boolean;
  filterCls: boolean;
  filterInp: boolean;
  filterTti: boolean;
  filterTbt: boolean;
  filterTtfb: boolean;
};

export type OpportunitiesWithID = WithID<Opportunity>;
export type SignalsWithID = WithID<Signal>;
export type GenerateSignalsResponseWithID = {
  signals: SignalsWithID[];
};

export interface OpportunityResponseWithId {
  opportunities: OpportunitiesWithID[];
}

export interface ParsedCriteria {
  userSegmentDefinitions: SegmentDefinition[];
  sessionSegmentDefinitions: SegmentDefinition[];
}

export const DateRangeIDtoConversionsDateRangeId: { [key in DateRangeID]: DateRangeId } = {
  [DateRangeID.AllTime]: DateRangeId.DATE_RANGE_ID_ALL_TIME,
  [DateRangeID.Today]: DateRangeId.DATE_RANGE_ID_TODAY,
  [DateRangeID.Yesterday]: DateRangeId.DATE_RANGE_ID_YESTERDAY,
  [DateRangeID.Past60Minutes]: DateRangeId.DATE_RANGE_ID_PAST_60_MINUTES,
  [DateRangeID.Past3Hours]: DateRangeId.DATE_RANGE_ID_PAST_3_HOURS,
  [DateRangeID.Past6Hours]: DateRangeId.DATE_RANGE_ID_PAST_6_HOURS,
  [DateRangeID.Past24Hours]: DateRangeId.DATE_RANGE_ID_PAST_24_HOURS,
  [DateRangeID.PastWeek]: DateRangeId.DATE_RANGE_ID_PAST_WEEK,
  [DateRangeID.PastMonth]: DateRangeId.DATE_RANGE_ID_PAST_MONTH,
  [DateRangeID.Past90Days]: DateRangeId.DATE_RANGE_ID_PAST_90_DAYS,
  [DateRangeID.PastYear]: DateRangeId.DATE_RANGE_ID_PAST_YEAR,
  [DateRangeID.Since]: DateRangeId.DATE_RANGE_ID_SINCE,
  [DateRangeID.Custom]: DateRangeId.DATE_RANGE_ID_CUSTOM,
};

export const ConversionsDateRangeIdToDateRangeID: { [key in DateRangeId]: DateRangeID | null } = {
  [DateRangeId.DATE_RANGE_ID_ALL_TIME]: DateRangeID.AllTime,
  [DateRangeId.DATE_RANGE_ID_TODAY]: DateRangeID.Today,
  [DateRangeId.DATE_RANGE_ID_YESTERDAY]: DateRangeID.Yesterday,
  [DateRangeId.DATE_RANGE_ID_PAST_60_MINUTES]: DateRangeID.Past60Minutes,
  [DateRangeId.DATE_RANGE_ID_PAST_3_HOURS]: DateRangeID.Past3Hours,
  [DateRangeId.DATE_RANGE_ID_PAST_6_HOURS]: DateRangeID.Past6Hours,
  [DateRangeId.DATE_RANGE_ID_PAST_24_HOURS]: DateRangeID.Past24Hours,
  [DateRangeId.DATE_RANGE_ID_PAST_WEEK]: DateRangeID.PastWeek,
  [DateRangeId.DATE_RANGE_ID_PAST_MONTH]: DateRangeID.PastMonth,
  [DateRangeId.DATE_RANGE_ID_PAST_90_DAYS]: DateRangeID.Past90Days,
  [DateRangeId.DATE_RANGE_ID_PAST_YEAR]: DateRangeID.PastYear,
  [DateRangeId.DATE_RANGE_ID_CUSTOM]: DateRangeID.Custom,
  [DateRangeId.DATE_RANGE_ID_SINCE]: DateRangeID.Since,
  [DateRangeId.DATE_RANGE_ID_INVALID]: null,
};

export const DimensionTypes = [
  DimensionType.DIMENSION_TYPE_BROWSER,
  DimensionType.DIMENSION_TYPE_DEVICE,
  DimensionType.DIMENSION_TYPE_LOCATION,
  DimensionType.DIMENSION_TYPE_OS,
  DimensionType.DIMENSION_TYPE_SCREEN,
  DimensionType.DIMENSION_TYPE_REFERRER,
];

export const SignalTypeNames = {
  [SignalType.SIGNAL_TYPE_INVALID]: intl.formatMessage({ defaultMessage: 'Invalid', id: '89T/ze' }),
  [SignalType.SIGNAL_TYPE_PERF_EVENT]: intl.formatMessage({
    defaultMessage: 'First Contentful Paint',
    id: 'urfe0A',
  }),
  [SignalType.SIGNAL_TYPE_CUSTOM_EVENT]: intl.formatMessage({
    defaultMessage: 'Custom Event',
    id: 'EZee9x',
  }),
  [SignalType.SIGNAL_TYPE_SEEN_EVENT]: intl.formatMessage({
    defaultMessage: 'Watched Element',
    id: 'Xt+LqS',
  }),
  [SignalType.SIGNAL_TYPE_CUSTOM]: intl.formatMessage({
    defaultMessage: 'Custom Query',
    id: 'ZqfTYe',
  }),
  [SignalType.SIGNAL_TYPE_DEFINED_EVENT]: intl.formatMessage({
    defaultMessage: 'Defined Event',
    id: 'cdB6Ru',
  }),
  [SignalType.SIGNAL_TYPE_AJAX_ERROR]: intl.formatMessage({
    defaultMessage: 'Network Error',
    id: 'Ddub4p',
  }),
  [SignalType.SIGNAL_TYPE_CORE_WEB_VITALS]: intl.formatMessage({
    defaultMessage: 'Core Web Vitals',
    id: 'KWZzii',
  }),
  [SignalType.SIGNAL_TYPE_PAGE_VIEW]: intl.formatMessage({
    defaultMessage: 'Page View',
    id: 'JJ4Yd9',
  }),
  [SignalType.SIGNAL_TYPE_FID]: intl.formatMessage({
    defaultMessage: 'First Input Delay',
    id: 'R6PebY',
  }),
  [SignalType.SIGNAL_TYPE_LCP]: intl.formatMessage({
    defaultMessage: 'Largest Contentful Paint',
    id: 'EKMCMF',
  }),
  [SignalType.SIGNAL_TYPE_CLS]: intl.formatMessage({
    defaultMessage: 'Cumulative Layout Shift',
    id: 'h6rdDs',
  }),
  [SignalType.SIGNAL_TYPE_INP]: intl.formatMessage({
    defaultMessage: 'Interaction to Next Paint',
    id: '28roqn',
  }),
  [SignalType.SIGNAL_TYPE_TTI]: intl.formatMessage({
    defaultMessage: 'Time to Interactive',
    id: 'dE1fN6',
  }),
  [SignalType.SIGNAL_TYPE_TBT]: intl.formatMessage({
    defaultMessage: 'Total Blocking Time',
    id: '8exg/e',
  }),
  [SignalType.SIGNAL_TYPE_TTFB]: intl.formatMessage({
    defaultMessage: 'Time to First Byte',
    id: 'LlmkZl',
  }),
};

export const InputBadClickTypes = {
  [BadClickType.CLICK_TYPE_INVALID]: intl.formatMessage({
    defaultMessage: 'Invalid',
    id: '89T/ze',
  }),
  [BadClickType.CLICK_TYPE_RAGE]: intl.formatMessage({
    defaultMessage: 'Rage Click',
    id: 'PSUo53',
  }),
  [BadClickType.CLICK_TYPE_ERROR]: intl.formatMessage({
    defaultMessage: 'Error Click',
    id: '0USC1d',
  }),
  [BadClickType.CLICK_TYPE_DEAD]: intl.formatMessage({
    defaultMessage: 'Dead Click',
    id: 'hsHG36',
  }),
};

export interface Step {
  total: number;
  value: number;
}

export type ParsedImpactsTableConfig = ImpactsTableConfig & {
  ParsedFunnel: FunnelDetail | null;
  ParsedSegment: SegmentDetail | null;
};

export interface RevenueEventForm {
  eventName: CustomEvent['name'] | null;
  eventProperty: string | null;
  currency: DisplayCurrencyType;
  // These are default values that don't mean much for now
  id: int64 | null;
  disabled: boolean;
}

export type GenerateOpportunitiesProgress = {
  completed: number;
  total: number;
};

export const CurrencyFromCurrencyType = {
  [DisplayCurrencyType.CURRENCY_USD]: 'USD ($)',
  [DisplayCurrencyType.CURRENCY_EUR]: 'EUR (€)',
  [DisplayCurrencyType.CURRENCY_GBP]: 'GBP (£)',
  [DisplayCurrencyType.CURRENCY_YEN]: 'JPY (¥)',
  [DisplayCurrencyType.CURRENCY_AED]: 'AED (د.إ)',
  [DisplayCurrencyType.CURRENCY_AUD]: 'AUD (A$)',
  [DisplayCurrencyType.CURRENCY_BRL]: 'BRL (R$)',
  [DisplayCurrencyType.CURRENCY_CAD]: 'CAD (CA$)',
  [DisplayCurrencyType.CURRENCY_CLP]: 'CLP ($)',
  [DisplayCurrencyType.CURRENCY_ILS]: 'ILS (₪)',
  [DisplayCurrencyType.CURRENCY_INR]: 'INR (₹)',
  [DisplayCurrencyType.CURRENCY_MXN]: 'MXN (MX$)',
  [DisplayCurrencyType.CURRENCY_THB]: 'THB (฿)',
  [DisplayCurrencyType.CURRENCY_TRY]: 'TRY (₺)',
  [DisplayCurrencyType.CURRENCY_CHF]: 'CHF (CHF)',
  [DisplayCurrencyType.CURRENCY_SEK]: 'SEK (kr)',
  [DisplayCurrencyType.CURRENCY_INVALID]: '',
};

type SpecSignals = {
  customEvents: CustomEvent[];
  seenEvents: SeenEvent[];
  pageviewEvents: PageView[];
};

export type NewConfigOptions = {
  splitWebVitals: boolean;
  defaultSpecSignals?: SpecSignals;
};
